import axios from "axios";
import { getAPIBaseURL, logout, adminLogout, getAdmin } from "./helpers";

// Configure axios defaults to send credentials (cookies) with all requests
axios.defaults.withCredentials = true;

// Helper to determine if we're in admin context
const isAdminRoute = () => {
  const admin = getAdmin()
  const currentPath = window.location.pathname
  // Exclude login routes from admin context
  const isLoginRoute = currentPath === '/admin/login' || currentPath === '/login'
  return !!(admin || (currentPath.startsWith('/admin') && !isLoginRoute))
}

// Helper to handle auth errors
const handleAuthError = (error) => {
  const isAdmin = isAdminRoute()
  if (isAdmin) {
    adminLogout()
    window.location.href = '/admin/login'
  } else {
    logout()
    window.location.href = '/login'
  }
}

// Axios response interceptor for global 401 handling
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    // Don't redirect if we're on a login page (to avoid redirect loops)
    const currentPath = window.location.pathname
    const isLoginRoute = currentPath === '/admin/login' || currentPath === '/login'
    
    if (error?.response?.status === 401 && !isLoginRoute) {
      const errorMessage = error?.response?.data?.data || error?.response?.data?.message || ''
      if (errorMessage === 'Token expired' || 
          errorMessage.includes('expired') || 
          errorMessage === 'unauthorized' || 
          errorMessage.includes('invalid token') ||
          errorMessage === 'Unauthorized') {
        handleAuthError(error)
      }
    }
    return Promise.reject(error)
  }
)

export const postData = async (url, headers, data) => {
  try{
    const res = await axios.post(url, data, {headers: headers, withCredentials: true});
    return {error: "", result: res};
  }catch(error){
    // Handle token expiration or unauthorized access (but not on login routes)
    const currentPath = window.location.pathname
    const isLoginRoute = currentPath === '/admin/login' || currentPath === '/login'
    
    if(error?.response?.status === 401 && !isLoginRoute){
      const errorMessage = error?.response?.data?.data || error?.response?.data?.message || ''
      if(errorMessage === 'Token expired' || 
         errorMessage.includes('expired') || 
         errorMessage === 'unauthorized' || 
         errorMessage.includes('invalid token') ||
         errorMessage === 'Unauthorized'){
        handleAuthError(error)
        return {error: "error", result: error?.response}
      }
    }
    return {error: "error", result: error?.response}
  }
}

export const updateData = async (url, headers, data) => {
  try{
    const res = await axios.put(url, data, {headers: headers, withCredentials: true});
    return {error: "", result: res};
  }catch(error){
    // Handle token expiration or unauthorized access (but not on login routes)
    const currentPath = window.location.pathname
    const isLoginRoute = currentPath === '/admin/login' || currentPath === '/login'
    
    if(error?.response?.status === 401 && !isLoginRoute){
      const errorMessage = error?.response?.data?.data || error?.response?.data?.message || ''
      if(errorMessage === 'Token expired' || 
         errorMessage.includes('expired') || 
         errorMessage === 'unauthorized' || 
         errorMessage.includes('invalid token') ||
         errorMessage === 'Unauthorized'){
        handleAuthError(error)
        return {error: "error", result: error?.response}
      }
    }
    if(error?.response?.status == 422){
      const isAdmin = isAdminRoute()
      window.location.href = isAdmin ? '/admin/login' : '/login'
    }
    return {error: "error", result: error?.response}
  }
}

export const getData = async (url, headers, params) => {
  try{   
    const res = await axios.get(url, {params:params, headers: headers, withCredentials: true, credentials: 'include' });
    return {error: "", result: res};
  }catch(error){
    // Handle token expiration or unauthorized access (but not on login routes)
    const currentPath = window.location.pathname
    const isLoginRoute = currentPath === '/admin/login' || currentPath === '/login'
    
    if(error?.response?.status === 401 && !isLoginRoute){
      const errorMessage = error?.response?.data?.data || error?.response?.data?.message || ''
      if(errorMessage === 'Token expired' || 
         errorMessage.includes('expired') || 
         errorMessage === 'unauthorized' || 
         errorMessage.includes('invalid token') ||
         errorMessage === 'Unauthorized'){
        handleAuthError(error)
        return {error: "error", result: error?.response}
      }
    }
    return {error: "error", result: error?.response}
  }
}

export const deleteData = async (url, headers, params) => {
  try{
    const res = await axios.delete(url, {params:params, headers: headers, withCredentials: true});
    return {error: "", result: res};
  }catch(error){
    // Handle token expiration or unauthorized access (but not on login routes)
    const currentPath = window.location.pathname
    const isLoginRoute = currentPath === '/admin/login' || currentPath === '/login'
    
    if(error?.response?.status === 401 && !isLoginRoute){
      const errorMessage = error?.response?.data?.data || error?.response?.data?.message || ''
      if(errorMessage === 'Token expired' || 
         errorMessage.includes('expired') || 
         errorMessage === 'unauthorized' || 
         errorMessage.includes('invalid token') ||
         errorMessage === 'Unauthorized'){
        handleAuthError(error)
        return {error: "error", result: error?.response}
      }
    }
    if(error?.response?.status == 422){
      const isAdmin = isAdminRoute()
      window.location.href = isAdmin ? '/admin/login' : '/login'
    }
    return {error: "error", result: error?.response}
  }
}
